import casinoConfig from '@dcentralexpedientedigital/config';
import { getCanonicalLocale } from '@dcentralexpedientedigital/fe-shared/utils/locale';

export function isValidLocale(locale?: string): locale is string {
    if (typeof locale !== 'string') {
        return false;
    }

    if (getCanonicalLocale(locale) === false) {
        return false;
    }

    const availableLocales = (casinoConfig.generalConfig?.availableLocales || []) as string[];

    if (!availableLocales.map((code) => code.toLowerCase()).includes(locale.toLocaleLowerCase())) {
        return false;
    }

    return true;
}
